import { Pipe, PipeTransform } from '@angular/core';


export class FontSizePipe implements PipeTransform {
  transform(value: string): number {
    return parseInt(value.replace(/[^-\d\.]/g, '') || '16');
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'FontSize',
  pure: true
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class FontStylesPipe implements PipeTransform {
  transform(value: string): string {
    let lookup = {
      '100': 'Thin',
      '200': 'Extra-Light',
      '300': 'Light',
      '400': 'Regular',
      '500': 'Medium',
      '600': 'Semi-bold',
      '700': 'Bold',
      '800': 'Extra-bold',
      '900': 'Black'
    };

    for (let style in lookup) {
      let found = value.search(style);

      if (found >= 0) {
        value = value.replace(style, lookup[style] + ' ');

        break;
      }
    }

    return value;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'FontStyles',
  pure: true
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class StatefulSlicePipe implements PipeTransform {
  private slicedArray = [];
  private previousArrayRef = [];
  private previousEndValue = null;

  transform(arr: any[], start: number, end: number): any {
    if (arr && (this.previousEndValue != end || this.previousArrayRef !== arr)) {
      this.slicedArray = arr.slice(start, end);

      this.previousArrayRef = arr;
      this.previousEndValue = end;
    }

    return this.slicedArray || arr;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'StatefulSlice',
  pure: false
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
